import React from 'react';
// Requires @orijinworks/frontend-commons with PlanStatusChip + statusSlot (CC-15432)
import { PlanStatusChip } from '@orijinworks/frontend-commons';
import {
  PLAN_STATUS,
  PLAN_STATUS_CHIP_LABEL,
  PLAN_STATUS_CHIP_TONES,
  PLAN_STATUS_LABELS,
  PLAN_STATUSES,
} from '../../../../constants/reentry-planning.constants';

const buildStatusOptions = (currentStatus) =>
  PLAN_STATUSES.map((value) => ({
    value,
    label: PLAN_STATUS_LABELS[value],
    disabled: value === PLAN_STATUS.DRAFT && currentStatus !== PLAN_STATUS.DRAFT,
  }));

export function CasePlanStatusControl({
  status,
  isEditor = false,
  isViewOnly = false,
  onSelect,
}) {
  const readOnly = isEditor !== true || isViewOnly === true;

  return (
    <PlanStatusChip
      label={PLAN_STATUS_CHIP_LABEL}
      valueLabel={PLAN_STATUS_LABELS[status] ?? ''}
      tone={PLAN_STATUS_CHIP_TONES[status] ?? 'neutral'}
      readOnly={readOnly}
      options={buildStatusOptions(status)}
      onSelect={onSelect}
    />
  );
}
